module.exports = __webpack_public_path__ + "static/img/ms.e147bd2b.svg";